import { Component, Input } from 'angular-ts-decorators';
import { Languages, ILanguageInfoObject } from '../../services/languages';
import { SwChange } from '../../classes/sw-change';

/**
 * Component to display all languages we know about, and allow user
 * user to choose one.
 *
 * # Example
 * <pre>
 *   <sw-language-picker sw-value="$ctrl.initialValue" sw-change="$ctrl.onChange(value)" sw-read-only="true"></sw-language-picker>
 * </pre>
 */
@Component({
  selector: 'swLanguagePicker',
  template: require('./sw-language-picker.html').default,
})
export class SwLanguagePickerComponent extends SwChange {
  @Input() swValue: string;
  @Input() swReadOnly: boolean;

  languageList: ILanguageInfoObject[];

  constructor(private languages: Languages) {
    'ngInject';
    super();
  }

  ngOnInit() {
    this.languageList = this.languages.getList();
  }
}
